module.exports = __webpack_public_path__ + "media/images/result_sets/icons/balance_icon-0ecb128967799a0e5668fbe3866fffd9.svg";